import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);
Vue.use(Meta);
const CustomerTemplate = {
  props: ["ID"],
  template: "<div>CustomerTemplate {{ test }}</div>",
};
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/BoothsView.vue"),
  },
  {
    path: "/home",
    name: "Base",
    component: HomeView,
  },
  {
    path: "/signin",
    name: "signin",

    component: () => import("../views/SigninView.vue"),
  },
  {
    path: "/booths",
    name: "booths",
    component: () => import("../views/BoothsView.vue"),
  },
  {
    path: "/createbooth",
    name: "createbooth",
    component: () => import("../views/CreateBooth.vue"),
  },
  {
    path: "/aroundme",
    name: "aroundme",
    beforeLeave: (to, from, next) => {
      localStorage.removeItem("token");
      next();
    },
    component: () => import("../views/AroundMeView.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/ProfileView"),
  },
  {
    path: "/profile/booths",
    name: "profilebooths",
    component: () => import("../components/profile/profilebooth"),
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("../views/NotFoundView.vue"),
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "NotFound",
  //   component: () => import("../views/NotFoundView.vue"),
  //   meta: {
  //     isFrontend: true,
  //   },
  // },
  {
    path: "/:name",
    name: "customertemplate",
    component: () => import("../views/CustomerTemplate"),
    children: [
      { path: "", name: "home" },
      // { path: "home", name: "home" },
      { path: "gallery", name: "gallery" },
      { path: "catalog", name: "catalog" },
      { path: "virtual-tour", name: "virtual_tour" },
      { path: "comments", name: "comments" },
      { path: "about-us", name: "aboutus" },
      { path: "products", name: "products" },
      { path: "products/:id", name: "products" },
      { path: "product/:id", name: "product" },
      { path: "cart", name: "cart" },
      { path: "myorders", name: "myorders" },
      { path: "checkout", name: "checkout" },
      { path: "Emalls", name: "emalls" },
      { path: "statepayment", name: "statepayment" },
      {
        path: "/login",
        name: "loginRegister",
        component: () =>
          import(
            "../components/customer_detials/storetemp_3/components/auth/signinandsignup.vue"
          ),
      },
      {
        path: "/category",
        name: "category",
        component: () =>
          import(
            "../components/customer_detials/storetemp_3/views/CategoryView.vue"
          ),
      },
      {
        path: "/cart",
        name: "cart",
        component: () =>
          import(
            "../components/customer_detials/storetemp_3/views/CartView.vue"
          ),
      },
      {
        path: "search",
        name: "search",
        props: (route) => ({ query: route.query.q }),
      },
      {
        path: "homestore",
        name: "homestore",
        // component: () =>
        //   import("@/components/customer_detials/storetemp_2/HomeStoreView.vue"),
      },
      {
        path: "",
        name: "menu",
        // component: () =>
        //   import("@/components/customer_detials/storetemp_2/MenuView.vue"),
      },
      {
        path: "preorder",
        name: "preOrder",
        // component: () =>
        //   import("@/components/customer_detials/storetemp_2/preOrderView.vue"),
      },
      {
        path: "order",
        name: "order",
        // component: () =>
        //   import("@/components/customer_detials/storetemp_2/OrderView.vue"),
      },
      {
        path: "myOrder",
        name: "myOrder",
        // component: () =>
        //   import("@/components/customer_detials/storetemp_2/MyOrderView.vue"),
      },
    ],
    props: true,
    beforeLeave: (to, from, next) => {
      localStorage.removeItem("token");
      next();
    },
  },
  {
    path: "/:name/loginStore",
    name: "login",
    component: () =>
      import("@/components/customer_detials/storetemp/loginAndRegister.vue"),
  },
  {
    path: "/:name/loginGold",
    name: "loginRegisterGold",
    component: () =>
      import("@/components/customer_detials/goldstore/loginAndRegister.vue"),
  },
  {
    path: "/new/:name",
    name: "newtemplate",
    component: () => import("../views/CustomerTemplate.vue"),
    props: true,
    beforeLeave: (to, from, next) => {
      localStorage.removeItem("token");
      next();
    },
  },

  // {
  //   path: "/namyalink",
  //   name: "namyalink",
  //   beforeLeave: (to, from, next) => {
  //     localStorage.removeItem("token");
  //     next();
  //   },
  //   component: () => import("../views/NamyaLink.vue"),
  // },
  // {
  //   path: "/smarttraffic",
  //   name: "smart_traffic",

  //   component: () => import("../views/SmartTraficView.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});



router.beforeEach((to, from, next) => {
  // to.meta.title = to.params.name;
  const publicPages = [
    "/",
    "/signin",
    "/register",
    "/booths",
    "/aroundme",
    "/home",
    "/404",
    "/" + to.params.name,
    "/" + to.params.name + "/",
    "/" + to.params.name + "/home",
    "/" + to.params.name + "/gallery",
    "/" + to.params.name + "/catalog",
    "/" + to.params.name + "/virtual-tour",
    "/" + to.params.name + "/comments",
    "/" + to.params.name + "/comments/",
    "/" + to.params.name + "/about-us",
    "/" + to.params.name + "/about-us/",
    "/" + to.params.name + "/products",
    "/" + to.params.name + "/products/",
    "/" + to.params.name + "/products/" + to.params.id,
    "/" + to.params.name + "/product/" + to.params.id,
    "/" + to.params.name + "/cart",
    "/" + to.params.name + "/cart/",
    "/" + to.params.name + "/myorders",
    "/" + to.params.name + "/myorders/",
    "/" + to.params.name + "/checkout",
    "/" + to.params.name + "/checkout/",
    "/" + to.params.name + "/loginStore",
    "/" + to.params.name + "/loginStore/",
    "/" + to.params.name + "/loginGold",
    "/" + to.params.name + "/loginGold/",
    "/" + to.params.name + "/search",
    "/" + to.params.name + "/search/",
    "/" + to.params.name + "/statepayment",
    "/" + to.params.name + "/menu",
    "/" + to.params.name + "/preorder",
    "/" + to.params.name + "/order",
    "/" + to.params.name + "/myOrder",
    "/" + to.params.name + "/homestore",
    "/" + to.params.name + "/Emalls",
    "/" + to.params.name + "/",
    "/new/" + to.params.name,
  ];
  // , '/register'
  // if (to.name == "customertemplate" && to.params.name != "") {
  //   //   window.location.href = 'http://www.namya.app/' + to.params.name
  //   window.location.href = "http://www." + to.params.name + ".ir";
  // }
  //   console.log(window.location.href)
  // if (window.$cookies.get('jwt') === null) { console.warn("jwt") }
  const authRequired = !publicPages.includes(to.path);
  // const authRequired = !publicPages.includes(
  //   to.matched[0].alias[0] ? to.matched[0].alias[0] : to.path
  // );
  const loggedIn = localStorage.getItem("token");
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (
    authRequired &&
    !loggedIn
    // jwtDecode(loggedIn).exp < Date.now() / 1000
  ) {
    next("/signin");
    localStorage.clear();
  } else {
    next();
  }
});

export default router;
